import {deserializeAs} from 'cerialize';
import {Address} from './Address';

export class UsagePoint {

  @deserializeAs('usage_point_id')
  usagePointId: number;

  @deserializeAs(Address, 'usage_point_addresses')
  address: number;
}
